var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"font-light text-3xl text-black flex justify-center p-14"},[_vm._v("-Rota Altınkalp Online Menu-")])])
}]

export { render, staticRenderFns }